<template>
  <div class="registerIndex">
    <div class="reg-main">
      <img src="@/assets/register/logo.png" alt="" @click="home" class="logo">
      <div class="center">
        <i class="el-icon-arrow-left icon-back" @click="back"></i>
        <h2 class="title">请选择您的注册类型</h2>
        <div class="reg-module" @click="regCompany(3)">
          <img class="icon" src="@/assets/register/icon_2.png" alt="">
          <div class="middle">
            <div class="name">企业大客户</div>
            <p class="desc">B2B自营专区，4小时响应，24小时上门 专业客服全流程跟踪，多项保险规避服务风险</p>
          </div>
          <i class="el-icon-arrow-right icon-link"></i>
        </div>
        <div class="reg-module" @click="regService">
          <img class="icon" src="@/assets/register/icon_3.png" alt="">
          <div class="middle">
            <div class="name">接单服务站</div>
            <p class="desc">承接服务工单，赚取服务费 参加速派组织的培训及考核，提升服务能力</p>
          </div>
          <i class="el-icon-arrow-right icon-link"></i>
        </div>
        <div class="reg-module" @click="regCompany(1)">
          <img class="icon" src="@/assets/register/icon_1.png" alt="">
          <div class="middle">
            <div class="name">普通企业</div>
            <p class="desc">众包平台，自由对接 专业能力标签，精准工单匹配</p>
          </div>
          <i class="el-icon-arrow-right icon-link"></i>
        </div>
      </div>
      <!-- <div class="reg-module">
        <h3 class="title">企业用户</h3>
        <div class="reg-item" @click="regCompany">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_1.png" alt="">
            <span class="label">企业发单客户</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_1_active.png" alt="">
              <div class="reg-dd">企业发单客户</div>
            </div>
            <p class="desc">平台匹配工单解决您的工业需求</p>
          </div>
        </div>
        <div class="reg-item" @click="regService">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_3.png" alt="">
            <span class="label">接单服务商</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_3_active.png" alt="">
              <div class="reg-dd">接单服务商</div>
            </div>
            <p class="desc">承接服务工单，赚取服务费；<br>参加速派组织的培训及考核，提升服务能力；</p>
          </div>
        </div>
      </div>
      <div class="reg-module">
        <h3 class="title">个人用户</h3>
        <div class="reg-item" @click="regUser">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_2.png" alt="">
            <span class="label">个人发单客户</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_2_active.png" alt="">
              <div class="reg-dd">个人发单客户</div>
            </div>
            <p class="desc">平台匹配工单解决您的工业需求</p>
          </div>
        </div>
        <div class="reg-item" @click="regEngineer">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_4.png" alt="">
            <span class="label">接单工程师</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_4_active.png" alt="">
              <div class="reg-dd">接单工程师</div>
            </div>
            <p class="desc">承接服务工单，赚取服务费；<br>参加速派组织的培训及考核，提升服务能力的同时，可以承接企业定制工单；</p>
          </div>
        </div>
      </div> -->
    </div>
    <gk-footer></gk-footer>
  </div>
</template>

<script>
import {bpoAppQrcode} from '@/scripts/bpo.js'
import gkFooter from '@/components/footer.vue'
export default {
  name: 'registerIndex',
  components:{
    gkFooter
  },
  data(){
    return{
      showQrcode:false,
    }
  },
  created() {
  },
  methods: {
    back(){
      this.$router.back();
    },
    home(){
      this.$router.replace('/');
    },
    regCompany(type){
      //type 1:普通企业,2:服务站，3,大客户
      this.$router.push({path:'/companyRegister',query:{type}});
    },
    regService(){
      this.$router.push({path:'/serviceRegister',query:{type:2}});
    },
    regUser(){
      this.$router.push('/personRegister');
    },
    regEngineer(){
      bpoAppQrcode();
    },
  },
}
</script>

<style lang="scss">
.registerIndex{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 68px;
  background: url('~@/assets/register/bg.png') no-repeat center top;
  background-size: cover;
  .reg-main{
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    margin-left: -260px;
    margin-top: -400px;
    .logo{
      display: block;
      width: 203px;
      height: 42px;
      margin: 0 auto 26px;
    }
    .center{
      width: 520px;
      height: 600px;
      margin: 0 auto;
      padding: 30px 60px;
      background-color: #fff;
      position: relative;
      border-radius: 10px;
      box-shadow: 0px 2px 20px 0px rgba(34, 23, 20, 0.1);
      position: relative;
    }
    .title{
      font-size: 24px;
      color: #333;
      line-height: 40px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .icon-back{
      font-size: 36px;
      color: #333;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      position: absolute;
      left: 14px;
      top: 30px;
      font-weight: bold;
      cursor: pointer;
      &:hover{
        color: #333;
      }
    }
  }
  .reg-module{
    float: left;
    width: 400px;
    height: 100px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    background-color: #fff;
    padding: 10px 15px;
    margin-bottom: 30px;
    cursor: pointer;
    &:hover{
      box-shadow: 0px 2px 20px 0px rgba(34, 23, 20, 0.1);
      .icon-link{
        color: #000;
        font-weight: bold;
      }
    }
    .icon{
      float: left;
      width: 44px;
      height: 44px;
      margin-right: 12px;
    }
    .middle{
      float: left;
      width: 280px;
    }
    .name{
      font-size: 20px;
      color: #333;
      line-height: 30px;
      font-weight: bold;
    }
    .desc{
        font-size: 14px;
        color: #999;
        line-height: 24px;
        word-break: break-all;
      }
    .icon-link{
      float: right;
      color: #333;
      line-height: 30px;
    }
  }
  #footer{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 40px;
    text-align: center;
    span{
      color: #333;
    }
    a{
      color: #333;
    }
  }
}


</style>